import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { MatMenuModule } from "@angular/material/menu";
import { MatRadioModule } from "@angular/material/radio";
import { ModulosDeFormulario } from "src/app/utils/formsModules";

@Component({
  selector: 'sub-filtro-status-tarefa',
  templateUrl: './status-tarefa.component.html',
  styleUrls: ['../../filtro.component.scss'],
  imports: [
    CommonModule,
    ModulosDeFormulario,
    MatRadioModule,
    MatMenuModule
  ],
})
export class StatusTarefaComponent {
	@Input('listaStatusTarefa') listaStatusTarefa: any = {};
	@Input('statusSelecionado') statusSelecionado: number = 0;
	@Output() atualizaFiltroStatusTarefa = new EventEmitter<{ tarefa: any; newValue: boolean }>();
}
